import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

import ERRORS, { ERROR_CODES } from './errors'
import { ERROR_ACTION_TYPE } from '../../constants'
import WGCWXConfirmation from 'components/WGCWXConfirmation/WGCWXConfirmation'

import styles from './Error.scss'

const Error = (props) => {
    const { onClose, error, errorActionType, caption } = props
    const errorData = () => {
        switch (errorActionType) {
        case ERROR_ACTION_TYPE.LEADERBOARDS_ERROR:
            return ERRORS[error] ? ERRORS[error] : ERRORS[ERROR_CODES.UNKNOWN_ERROR]
        case ERROR_ACTION_TYPE.GET_REWARDS_ERROR:
            return ERRORS[ERROR_CODES.GET_REWARD_ERROR]
        }
    }

    const { title, description } = errorData()
    const errorClassNames = classNames(styles.base, styles.base__overlayOpened)

    return (
        <div className={errorClassNames}>
            <div className={styles.background} />
            <WGCWXConfirmation
                messageType="error"
                title={title}
                description={description}
                buttonsOptions={[
                    {
                        caption: caption,
                        callback: () => onClose(),
                    },
                ]}
                onClose={onClose}
            />
        </div>
    )
}

Error.propTypes = {
    error: PropTypes.string,
    errorActionType: PropTypes.string,
    caption: PropTypes.string,
    onClose: PropTypes.func.isRequired,
}

export default Error


// WEBPACK FOOTER //
// ./containers/WGCWXLeaderboards/components/Error/Error.jsx